import { PillSizeVariant } from "./types";

export const DEFAULT_PILL_SIZE: PillSizeVariant = "md";

export const PillSizes: PillSizeVariant[] = ["xs", "sm", "md", "lg"];
